import { memo } from 'react';

type SvgProps = React.ComponentPropsWithoutRef<'svg'>;

export const ChartIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Y axis */}
      <path d="M3 3v18h18" />
      {/* Line chart */}
      <path d="M7 14l4-4 3 3 5-7" />
    </svg>
  );
});

ChartIcon.displayName = 'ChartIcon';
